var _style, _path, _defs, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _path8, _path9, _path0, _path1, _path10, _polygon4, _polygon5, _path11, _path12, _polygon6, _path13, _path14, _path15, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHxBr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bandera",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.7 453.2",
    style: {
      enableBackground: "new 0 0 511.7 453.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000077285925035026143370000017120283704153859479_);fill:#3D9244;}\n\t.st1{clip-path:url(#SVGID_00000077285925035026143370000017120283704153859479_);fill:#ECC023;}\n\t.st2{clip-path:url(#SVGID_00000077285925035026143370000017120283704153859479_);}\n\t.st3{fill:#30276C;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#3D9244;}\n\t.st6{fill:#3D9244;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.6,0H149.3c-15.1,0-29.1,8.1-36.7,21.2L6,205.4c-7.6,13.1-7.6,29.4,0,42.5l106.6,184.2c7.6,13.1,21.6,21.2,36.7,21.2 h213.4c15.1,0,29.1-8.1,36.7-21.2L506,247.9c7.6-13.1,7.6-29.4,0-42.5L399.4,21.2C391.8,8.1,377.8,0,362.6,0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M118.6,432.8L8.7,242.5c-5.7-9.8-5.7-22,0-31.8L118.6,20.4c5.7-9.8,16.2-15.9,27.6-15.9h219.7 c11.4,0,21.9,6.1,27.5,15.9l109.9,190.3c5.7,9.8,5.7,22,0,31.8L393.4,432.8c-5.7,9.8-16.2,15.9-27.5,15.9H146.1 C134.8,448.7,124.3,442.7,118.6,432.8L118.6,432.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007421301419527344630000010155000761388017039_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000007421301419527344630000010155000761388017039_)",
      fill: "#3D9244"
    },
    width: 511.6,
    height: 453.2
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000007421301419527344630000010155000761388017039_)",
      fill: "#ECC023"
    },
    points: "78.9,223.5  255.8,336.5 432.8,223.5 255.8,110.6  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000007421301419527344630000010155000761388017039_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.4,223.5c0,41.2-33.4,74.6-74.6,74.6s-74.6-33.4-74.6-74.6s33.4-74.6,74.6-74.6S330.4,182.4,330.4,223.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M213.2,191.5c-8.8,0-17.3,0.7-25.7,1.8c-1.6,3.7-2.9,7.5-4,11.4c9.6-1.6,19.5-2.6,29.6-2.6 c43.7,0,83.7,16.5,113.8,43.6c1.2-3.8,2.1-7.8,2.6-11.8C298.2,207.5,257.6,191.5,213.2,191.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M192.2,201.7c1.7-0.2,3-1.9,2.7-3.9c-0.2-1.9-1.8-3.4-3.6-3.1c-1.8,0.2-3,2-2.7,3.9 C188.8,200.5,190.4,201.9,192.2,201.7 M192,200.4c1-0.1,1.7-1.2,1.6-2.5c-0.1-1.2-1.1-2.1-2.1-2s-1.8,1.2-1.6,2.4 C190,199.7,191,200.5,192,200.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198,201.1l1.3-0.1l-0.2-2.6l2.9-0.2c1.2-0.1,2.1-1.2,2.1-2.4c-0.1-1.2-1.2-2.2-2.4-2.1l-4.1,0.3L198,201.1z  M199,197l2.7-0.2c0.5-0.1,0.8-0.5,0.8-1c-0.1-0.5-0.4-0.9-0.9-0.8l-2.8,0.1L199,197z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M204,200.7c-0.1-1-0.2-3.2-1.7-3.2l-1.9,0.1c2.2-0.1,2.4,2.1,2.5,3.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207,200.5l3.3-0.1c1.7,0,3-1.4,3-3.1l-0.1-1c0-1.6-1.4-3-3.1-3l-3.3,0.1L207,200.5L207,200.5z M208.3,199.2 h1.9c1.1,0,1.9-0.9,1.9-1.9v-0.6c0-1-0.9-1.9-1.9-1.9h-2L208.3,199.2L208.3,199.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "215.9,200.4 222.4,200.7 222.4,199.3 217.3,199.1 217.3,197.3 221.4,197.4 221.4,196.2 217.4,196.1  217.4,194.7 222.3,194.9 222.3,193.5 216.2,193.3  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "225,200.8 226.2,200.9 226.7,196.1 227.6,201 228.8,201.1 230.6,196.4 230.2,201.2 231.4,201.4  232,194.3 230.3,194.1 228.4,198.9 227.4,193.9 225.6,193.7  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "239.7,202.5 245,203.4 245.2,202.2 241.1,201.5 241.4,199.9 244.8,200.4 244.9,199.2 241.7,198.7  241.8,197.6 245.7,198.2 245.9,197 240.8,196.1  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253.2,205.1l1.2,0.3l0.7-2.6l2.7,0.7c1.2,0.3,2.4-0.4,2.8-1.6c0.3-1.2-0.5-2.4-1.6-2.7l-3.9-1L253.2,205.1 L253.2,205.1z M255.5,201.6l2.6,0.7c0.5,0.1,1-0.2,1.1-0.7s-0.2-1-0.6-1.1l-2.6-0.7L255.5,201.6L255.5,201.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M261.9,207.4l1.3,0.4l0.8-2.5l2.6,0.9c1.2,0.4,2.4-0.3,2.8-1.4c0.4-1.2-0.3-2.4-1.4-2.8l-3.9-1.2L261.9,207.4 L261.9,207.4z M264.4,204l2.6,0.8c0.4,0.1,1-0.1,1.1-0.6c0.2-0.5-0.1-1-0.6-1.1l-2.6-0.8L264.4,204L264.4,204z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M267.7,209.2c0.3-1,1-3.1-0.5-3.5l-1.8-0.6c2.1,0.7,1.4,2.8,1.1,3.8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M273.5,211.3c1.7,0.6,3.5-0.4,4.2-2.2c0.7-1.9-0.1-3.8-1.7-4.4c-1.7-0.6-3.6,0.4-4.3,2.2 C271,208.7,271.9,210.7,273.5,211.3 M274,210.1c1,0.4,2.1-0.3,2.6-1.4c0.5-1.2,0-2.4-1-2.8c-1-0.3-2.1,0.3-2.6,1.4 C272.5,208.5,273,209.7,274,210.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M281.9,214.7c1.6,0.7,3.6-0.2,4.4-2c0.7-1.8,0.1-3.8-1.5-4.5s-3.5,0.2-4.3,2C279.6,212,280.3,214,281.9,214.7  M282.4,213.5c1,0.4,2.1-0.2,2.6-1.3s0.1-2.4-0.8-2.8c-1-0.4-2.1,0.2-2.6,1.3S281.4,213.1,282.4,213.5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "283.8,211.7 286.3,212.7 285.8,213.7 283.4,212.6  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "285.3,212.3 286.3,212.7 284.8,216 283.9,215.6  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M287.2,217.1l1.2,0.6l1.2-2.4l2.5,1.3c1.1,0.6,2.4,0.1,3-1s0.1-2.5-1-3l-3.6-1.8L287.2,217.1L287.2,217.1z  M290.2,214.2l2.4,1.2c0.5,0.2,1,0.1,1.2-0.4c0.2-0.4,0.1-1-0.4-1.2l-2.5-1.2L290.2,214.2L290.2,214.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M292.6,219.8c0.5-0.9,1.4-2.9,0.1-3.6l-1.8-0.9c2,1,1,3,0.6,3.9"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "295.2,221.2 300.9,224.3 301.4,223.2 297,220.6 297.8,219.1 301.4,221.1 302,220 298.5,218  299.2,216.7 303.4,219.1 304.1,218 298.7,215  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M305.6,224.7c-0.4,0.6,0,1.3,0.8,1.8c0.9,0.5,1.4,0.5,1.7,0.1c0.8-1.2-3.7-3-2.3-5.1c1.2-1.8,3.2-0.4,4,0.1 s2,1.8,1,3.2l-1.3-0.9c0.5-0.6,0-1.2-0.7-1.6c-0.7-0.5-1.2-0.7-1.6,0c-0.7,1,3.8,2.8,2.4,5c-0.9,1.6-2.7,0.9-3.8,0.1 c-1-0.6-2.5-2.1-1.5-3.6L305.6,224.7L305.6,224.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.3,229.7c-0.5,0.6-0.1,1.3,0.7,1.9s1.5,0.6,1.7,0.2c0.8-1.2-3.6-3.2-2-5.2c1.3-1.8,3.3-0.2,4,0.3 c0.8,0.6,1.9,1.9,0.8,3.3l-1.2-0.9c0.4-0.6,0-1.2-0.7-1.7s-1.1-0.7-1.5-0.1c-0.7,0.9,3.5,3.1,2.1,5.1c-1.1,1.5-2.8,0.7-3.9-0.1 c-1-0.7-2.4-2.2-1.3-3.7L313.3,229.7L313.3,229.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M320.4,237.9c1.4,1.1,3.5,0.7,4.7-0.8c1.2-1.6,1.1-3.7-0.3-4.8s-3.5-0.8-4.7,0.8 C319,234.7,319.1,236.8,320.4,237.9 M321.3,236.8c0.8,0.7,2.1,0.4,2.9-0.6s0.7-2.3-0.1-2.9c-0.8-0.7-2-0.4-2.8,0.6 C320.4,234.9,320.4,236.2,321.3,236.8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "194.9,206.9 193.9,210 195.4,210.5  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "194.9,206.9 195.9,210 194.4,210.5  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "197.9,209.1 194.7,209.1 194.7,210.7  "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "197.9,209.1 195.4,211 194.4,209.7  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "191.9,209.1 194.4,211 195.4,209.7  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "191.9,209.1 195.1,209.1 195.1,210.7  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "196.8,212.7 195.8,209.7 194.3,210.2  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "196.8,212.7 194.2,210.8 195.1,209.5  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "193,212.7 195.6,210.8 194.7,209.5  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "193,212.7 194,209.7 195.6,210.2  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "201.5,238.3 200.5,241.3 202.1,241.8  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "201.5,238.3 202.5,241.3 201,241.8  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "204.5,240.5 201.4,240.5 201.4,242.1  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "204.5,240.5 202,242.4 201,241.1  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "198.5,240.5 201,242.4 202,241.1  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "198.5,240.5 201.7,240.5 201.7,242.1  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "203.4,244.1 202.4,241 200.9,241.5  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "203.4,244.1 200.8,242.2 201.7,240.9  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "199.6,244.1 202.2,242.2 201.3,240.9  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "199.6,244.1 200.6,241 202.1,241.5  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "192.4,246 191.8,248.1 192.8,248.4  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "192.4,246 193,248.1 192,248.4  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "194.4,247.5 192.2,247.5 192.2,248.6  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "194.4,247.5 192.7,248.8 192.1,247.9  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "190.4,247.5 192.1,248.8 192.7,247.9  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "190.4,247.5 192.5,247.5 192.5,248.6  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "193.6,249.9 192.9,247.9 192,248.2  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "193.6,249.9 191.9,248.6 192.5,247.8  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "191.1,249.9 192.8,248.6 192.2,247.8  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "191.1,249.9 191.8,247.9 192.8,248.2  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "208.8,235.4 208.3,236.8 209,237.1  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "208.8,235.4 209.3,236.8 208.6,237.1  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "210.2,236.5 208.8,236.5 208.8,237.2  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "210.2,236.5 209,237.4 208.6,236.7  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "207.3,236.5 208.6,237.4 209,236.7  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "207.3,236.5 208.9,236.5 208.9,237.2  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "209.7,238.1 209.2,236.7 208.6,236.9  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "209.7,238.1 208.5,237.2 208.9,236.6  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "207.9,238.1 209.1,237.2 208.7,236.6  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "207.9,238.1 208.4,236.7 209.1,236.9  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "217.1,246.2 216.2,248.8 217.4,249.2  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "217.1,246.2 217.8,248.8 216.6,249.2  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "219.5,248.1 216.9,248.1 216.9,249.4  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "219.5,248.1 217.4,249.6 216.6,248.5  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "214.5,248.1 216.6,249.6 217.4,248.5  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "214.5,248.1 217.2,248.1 217.2,249.4  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.6,251 217.8,248.5 216.5,248.9  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.6,251 216.4,249.5 217.2,248.4  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "215.5,251 217.6,249.5 216.8,248.4  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "215.5,251 216.3,248.5 217.6,248.9  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "214.8,253.6 214,256.2 215.2,256.6  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "214.8,253.6 215.6,256.2 214.4,256.6  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "217.3,255.5 214.7,255.5 214.7,256.8  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "217.3,255.5 215.2,257.1 214.4,256  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "212.3,255.5 214.4,257.1 215.2,256  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "212.3,255.5 215,255.5 215,256.8  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "216.4,258.5 215.6,255.9 214.3,256.3  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "216.4,258.5 214.2,256.9 215,255.8  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "213.3,258.5 215.4,256.9 214.6,255.8  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "213.3,258.5 214.1,255.9 215.3,256.3  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "278.9,197.2 278,200.2 279.5,200.7  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "278.9,197.2 280,200.2 278.4,200.7  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282,199.4 278.8,199.4 278.8,201  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282,199.4 279.4,201.3 278.5,200  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "275.9,199.4 278.5,201.3 279.4,200  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "275.9,199.4 279.1,199.4 279.1,201  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "280.8,203 279.8,199.9 278.3,200.4  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "280.8,203 278.2,201.1 279.2,199.8  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.1,203 279.6,201.1 278.7,199.8  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.1,203 278.1,199.9 279.6,200.4  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308,246.5 307.1,249.6 308.6,250.1  "
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308,246.5 309.1,249.6 307.6,250.1  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.1,248.7 307.9,248.7 307.9,250.3  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.1,248.7 308.6,250.6 307.6,249.3  "
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "305,248.7 307.6,250.6 308.6,249.3  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "305,248.7 308.2,248.7 308.2,250.3  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "310,252.3 309,249.3 307.5,249.7  "
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "310,252.3 307.4,250.4 308.4,249.1  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "306.2,252.3 308.8,250.4 307.8,249.1  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "306.2,252.3 307.2,249.3 308.7,249.7  "
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "318.5,248.3 317.8,250.3 318.8,250.6  "
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "318.5,248.3 319.1,250.3 318.1,250.6  "
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "320.4,249.8 318.4,249.8 318.4,250.8  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "320.4,249.8 318.7,251 318.1,250.1  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.4,249.8 318.1,251 318.8,250.1  "
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.4,249.8 318.6,249.8 318.6,250.8  "
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "319.7,252.1 319.1,250.1 318,250.4  "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "319.7,252.1 318,250.9 318.6,250  "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "317.2,252.1 318.9,250.9 318.3,250  "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "317.2,252.1 317.9,250.1 318.8,250.4  "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.1,253.6 310.4,256.2 311.6,256.6  "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.1,253.6 311.9,256.2 310.7,256.6  "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "313.6,255.5 311,255.5 311,256.8  "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "313.6,255.5 311.6,257.1 310.7,256  "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308.6,255.5 310.8,257.1 311.6,256  "
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308.6,255.5 311.3,255.5 311.3,256.8  "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "312.7,258.5 311.9,255.9 310.6,256.3  "
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "312.7,258.5 310.5,256.9 311.3,255.8  "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "309.6,258.5 311.7,256.9 310.9,255.8  "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "309.6,258.5 310.4,255.9 311.7,256.3  "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "293.2,269.3 292.3,271.8 293.6,272.2  "
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "293.2,269.3 294,271.8 292.7,272.2  "
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "295.7,271.1 293,271.1 293,272.5  "
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "295.7,271.1 293.5,272.7 292.8,271.6  "
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "290.7,271.1 292.8,272.7 293.5,271.6  "
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "290.7,271.1 293.3,271.1 293.3,272.5  "
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.7,274.1 293.9,271.6 292.6,272  "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.7,274.1 292.5,272.5 293.3,271.5  "
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291.6,274.1 293.8,272.5 293,271.5  "
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291.6,274.1 292.4,271.6 293.7,272  "
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "293,277.3 292.4,279.3 293.4,279.7  "
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "293,277.3 293.7,279.3 292.7,279.7  "
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "295.1,278.8 293,278.8 293,279.9  "
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "295.1,278.8 293.3,280 292.7,279.2  "
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291,278.8 292.8,280 293.4,279.2  "
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291,278.8 293.2,278.8 293.2,279.9  "
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.3,281.1 293.6,279.2 292.6,279.5  "
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.3,281.1 292.5,279.9 293.2,279.1  "
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291.8,281.1 293.5,279.9 292.9,279.1  "
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291.8,281.1 292.5,279.2 293.5,279.5  "
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "300.6,263.9 299.9,266 300.9,266.3  "
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "300.6,263.9 301.2,266 300.2,266.3  "
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "302.6,265.4 300.4,265.4 300.4,266.5  "
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "302.6,265.4 300.9,266.7 300.2,265.8  "
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "298.6,265.4 300.3,266.7 300.9,265.8  "
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "298.6,265.4 300.7,265.4 300.7,266.5  "
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "301.8,267.8 301.1,265.8 300.2,266.1  "
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "301.8,267.8 300.1,266.5 300.8,265.7  "
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "299.3,267.8 301.1,266.5 300.4,265.7  "
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "299.3,267.8 300,265.8 301,266.1  "
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "306.6,259.6 305.8,262.1 307,262.6  "
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "306.6,259.6 307.4,262.1 306.1,262.6  "
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "309.1,261.5 306.4,261.5 306.4,262.8  "
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "309.1,261.5 307,263 306.2,261.9  "
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "304,261.5 306.2,263 307,261.9  "
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "304,261.5 306.7,261.5 306.7,262.8  "
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308.1,264.4 307.3,261.9 306,262.3  "
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308.1,264.4 306,262.9 306.7,261.8  "
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "305,264.4 307.2,262.9 306.4,261.8  "
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "305,264.4 305.9,261.9 307.1,262.3  "
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "292.8,262.5 292.2,264.5 293.2,264.9  "
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "292.8,262.5 293.5,264.5 292.5,264.9  "
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.9,264 292.8,264 292.8,265  "
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.9,264 293.2,265.2 292.5,264.3  "
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "290.9,264 292.5,265.2 293.2,264.3  "
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "290.9,264 293,264 293,265  "
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.1,266.4 293.5,264.3 292.4,264.6  "
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "294.1,266.4 292.4,265.1 293,264.3  "
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291.6,266.4 293.3,265.1 292.7,264.3  "
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "291.6,266.4 292.3,264.3 293.3,264.6  "
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "227.4,223.9 226.6,226.4 227.9,226.8  "
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "227.4,223.9 228.2,226.4 226.9,226.8  "
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.9,225.7 227.3,225.7 227.3,227.1  "
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.9,225.7 227.8,227.3 227,226.2  "
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "224.8,225.7 227,227.3 227.8,226.2  "
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "224.8,225.7 227.5,225.7 227.5,227.1  "
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "228.9,228.7 228.2,226.2 226.9,226.6  "
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "228.9,228.7 226.8,227.1 227.6,226.1  "
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "225.8,228.7 228,227.1 227.2,226.1  "
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "225.8,228.7 226.7,226.2 227.9,226.6  "
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "276.1,217.6 275.5,219.6 276.5,220  "
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "276.1,217.6 276.8,219.6 275.8,220  "
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "278.2,219.1 276,219.1 276,220.2  "
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "278.2,219.1 276.4,220.4 275.8,219.5  "
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "274.1,219.1 275.8,220.4 276.4,219.5  "
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "274.1,219.1 276.3,219.1 276.3,220.2  "
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.4,221.5 276.7,219.5 275.7,219.8  "
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "277.4,221.5 275.6,220.2 276.3,219.4  "
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "274.9,221.5 276.6,220.2 276,219.4  "
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "274.9,221.5 275.5,219.5 276.5,219.8  "
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "255.8,253.8 254.8,256.9 256.3,257.4  "
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "255.8,253.8 256.8,256.9 255.3,257.4  "
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "258.8,256 255.7,256 255.7,257.6  "
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "258.8,256 256.3,257.9 255.4,256.6  "
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "252.8,256 255.4,257.9 256.3,256.6  "
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "252.8,256 255.9,256 255.9,257.6  "
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "257.7,259.6 256.7,256.6 255.2,257.1  "
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "257.7,259.6 255.1,257.7 256,256.4  "
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "253.9,259.6 256.5,257.7 255.6,256.4  "
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "253.9,259.6 254.9,256.6 256.5,257.1  "
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "264.5,239.5 263.6,242.1 264.9,242.5  "
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "264.5,239.5 265.3,242.1 264,242.5  "
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "267,241.4 264.3,241.4 264.3,242.7  "
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "267,241.4 264.8,242.9 264,241.9  "
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "261.9,241.4 264.1,242.9 264.9,241.9  "
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "261.9,241.4 264.6,241.4 264.6,242.7  "
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "266,244.4 265.2,241.8 263.9,242.2  "
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "266,244.4 263.9,242.8 264.6,241.7  "
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.9,244.4 265,242.8 264.3,241.7  "
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.9,244.4 263.7,241.8 265,242.2  "
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "255.8,232.9 255,235.4 256.2,235.8  "
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "255.8,232.9 256.6,235.4 255.4,235.8  "
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "258.3,234.7 255.7,234.7 255.7,236  "
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "258.3,234.7 256.2,236.2 255.4,235.2  "
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "253.3,234.7 255.5,236.2 256.2,235.2  "
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "253.3,234.7 255.9,234.7 255.9,236  "
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "257.4,237.6 256.6,235.1 255.3,235.5  "
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "257.4,237.6 255.2,236.1 256,235  "
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "254.2,237.6 256.4,236.1 255.6,235  "
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "254.2,237.6 255.1,235.1 256.3,235.5  "
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "248.3,240.1 247.6,242.1 248.7,242.4  "
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "248.3,240.1 249,242.1 247.9,242.4  "
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "250.3,241.5 248.2,241.5 248.2,242.6  "
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "250.3,241.5 248.6,242.8 247.9,241.9  "
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "246.3,241.5 248,242.8 248.6,241.9  "
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "246.3,241.5 248.4,241.5 248.4,242.6  "
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "249.6,243.9 248.9,241.9 247.9,242.2  "
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "249.6,243.9 247.9,242.7 248.5,241.8  "
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "247.1,243.9 248.8,242.7 248.1,241.8  "
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "247.1,243.9 247.7,241.9 248.7,242.2  "
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "252.1,245.9 251.6,247.3 252.3,247.5  "
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "252.1,245.9 252.5,247.3 251.8,247.5  "
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "253.5,246.9 252,246.9 252,247.6  "
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "253.5,246.9 252.3,247.8 251.9,247.2  "
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "250.6,246.9 251.9,247.8 252.3,247.2  "
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "250.6,246.9 252.1,246.9 252.1,247.6  "
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "252.9,248.6 252.5,247.2 251.8,247.4  "
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "252.9,248.6 251.7,247.7 252.2,247.1  "
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "251.2,248.6 252.4,247.7 251.9,247.1  "
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "251.2,248.6 251.7,247.2 252.4,247.4  "
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "278.2,271.1 277.3,273.6 278.6,274.1  "
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "278.2,271.1 279,273.6 277.7,274.1  "
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "280.7,272.9 278,272.9 278,274.3  "
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "280.7,272.9 278.5,274.5 277.8,273.4  "
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "275.6,272.9 277.8,274.5 278.6,273.4  "
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "275.6,272.9 278.3,272.9 278.3,274.3  "
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "279.7,275.9 278.9,273.4 277.6,273.8  "
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "279.7,275.9 277.6,274.4 278.3,273.3  "
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "276.6,275.9 278.7,274.4 278,273.3  "
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "276.6,275.9 277.4,273.4 278.7,273.8  "
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "284.5,265 283.9,267.1 284.9,267.4  "
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "284.5,265 285.2,267.1 284.1,267.4  "
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "286.6,266.5 284.4,266.5 284.4,267.5  "
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "286.6,266.5 284.9,267.8 284.2,266.9  "
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.5,266.5 284.2,267.8 284.9,266.9  "
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "282.5,266.5 284.6,266.5 284.6,267.5  "
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "285.8,268.9 285.1,266.9 284.1,267.2  "
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "285.8,268.9 284.1,267.6 284.7,266.8  "
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "283.3,268.9 285,267.6 284.4,266.8  "
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "283.3,268.9 284,266.9 285,267.2  "
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "272.3,263.2 271.6,265.2 272.6,265.6  "
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "272.3,263.2 272.9,265.2 271.9,265.6  "
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "274.3,264.7 272.1,264.7 272.1,265.8  "
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "274.3,264.7 272.5,266 271.9,265  "
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "270.2,264.7 271.9,266 272.5,265  "
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "270.2,264.7 272.4,264.7 272.4,265.8  "
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "273.5,267.1 272.9,265 271.8,265.4  "
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "273.5,267.1 271.8,265.8 272.4,265  "
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "271,267.1 272.7,265.8 272.1,265  "
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "271,267.1 271.6,265 272.7,265.4  "
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "225.9,259.9 224.9,262.9 226.4,263.4  "
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "225.9,259.9 226.8,262.9 225.4,263.4  "
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "228.9,262.1 225.7,262.1 225.7,263.7  "
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "228.9,262.1 226.3,264 225.4,262.7  "
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "222.8,262.1 225.5,264 226.3,262.7  "
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "222.8,262.1 226,262.1 226,263.7  "
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "227.7,265.7 226.8,262.7 225.3,263.1  "
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "227.7,265.7 225.2,263.8 226.1,262.5  "
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "224,265.7 226.6,263.8 225.6,262.5  "
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "224,265.7 225,262.7 226.5,263.1  "
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "255.8,280.8 255.5,281.8 255.9,282  "
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "255.8,280.8 256.1,281.8 255.7,282  "
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "256.9,281.6 255.7,281.6 255.7,282.1  "
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "256.9,281.6 255.9,282.2 255.7,281.7  "
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "254.8,281.6 255.7,282.2 255.9,281.7  "
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "254.8,281.6 255.8,281.6 255.8,282.1  "
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "256.4,282.7 256.1,281.7 255.6,281.9  "
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "256.4,282.7 255.6,282.1 255.8,281.7  "
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "255.2,282.7 256,282.1 255.7,281.7  "
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "255.2,282.7 255.5,281.7 256,281.9  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxBr);
export default __webpack_public_path__ + "static/media/hx-br.7489c852235d25090e9e7fbb4f30fe0d.svg";
export { ForwardRef as ReactComponent };